import React from 'react'

import { ContentGallerySwiper } from '@f-fertighaus/applications/Next/components/common/ContentGallerySwiper/ContentGallerySwiper'
import { HouseCarouselSkeletonLoader } from '@f-fertighaus/applications/Next/components/common/HouseCarouselSkeletonLoader'
import { HouseDetail } from '@f-fertighaus/applications/Next/types/houseDetailsResponse'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { isNotEmptyArray } from '@f-fertighaus/applications/Next/utils/typeguards/isNotEmptyArray'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'
import { HouseCard } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/components/HouseCard'
import { OTHER_VENDOR_HOUSES_NUMBER } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/constants/Constants'
import { usePopularVendorHousesData } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/usePopularVendorHousesData'

export const OtherVendorHousesCarousel = () => {
  const { vendor, state } = useHouseDetail()
  const { data: otherVendorHouses, status } = usePopularVendorHousesData(
    vendor.nid,
    OTHER_VENDOR_HOUSES_NUMBER
  )

  React.useEffect(() => {
    if (otherVendorHouses?.length) {
      webtrack({
        category: 'item-collection',
        action: 'display',
        label: 'other-houses',
        location: 'vendor-section',
        values: [{ type: 'house_nid', value: state.nid }]
      })
    }
  }, [state.nid, otherVendorHouses?.length])

  if (status === 'loading' || status === 'idle') {
    return <HouseCarouselSkeletonLoader />
  }

  if (!isNotEmptyArray(otherVendorHouses)) {
    return null
  }

  return (
    <ContentGallerySwiper<HouseDetail>
      data={otherVendorHouses}
      SlideCard={HouseCard}
      id='vendor-other-houses-swiper'
    />
  )
}
